module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Stranded_eBook-5.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "EB",
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "Foreword"
    }
  }, [_vm._v("Foreword")])]), _c('a', {
    attrs: {
      "id": "Foreword"
    }
  }, [_c('p', {
    staticClass: "BTCO"
  }, [_c('span', {
    staticClass: "IC"
  }, [_vm._v("P")]), _vm._v("assion. Obsession. Revenge. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("These three words would make a great tagline on a movie poster, and they are subjects Val McDermid tackles in her short stories. The mark of great shortstory writers, however, is that they not only unsettle their readers, shaking us out of complacency, but that they explore the psychology of human interaction. In his book of modern aphorisms, "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("The Book of Shadows")]), _vm._v(", the poet Don Paterson includes the following: ‘A mercy, I suppose, that it ended. Any deeper intimacy with each other’s anatomy would have involved a murder.’ ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Val McDermid could almost have written those words, including that wry and tangy ‘I suppose’. Of course, in Val’s world things often go far beyond Don Paterson’s imaginings, because the crimewriter recognises that love is the most destructive of emotions. It turns worlds upside down and people inside out. It can so easily turn to lust, or envy, or loathing. It can, and often does, lead to violence, both emotional and physical. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Val has always been a restless writer – the journey through her fictional universe could never have been made by a single, consistent hero or heroine – and the shortstory form suits her, allowing her to pick apart relationships with a furious skill, highlighting flaws and jealousies. The readers can see tragedy and horror emerging while the participants cannot. And always there are those twists awaiting us, just when we think we’ve seen it all. But Val is no fatalist: a dark humour infuses many of the stories here, and one story – ‘The Road and the Miles to Dundee’ – is very different to the others, allowing the author to explore her roots and the strong pull of family and background. It’s a hugely moving tale and one which shows her extraordinary range. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Those who have read her novel "), _c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("Killing the Shadows")]), _vm._v(" will be unsurprised that Val has a dark view of the writer’s life, exhibited here in no fewer than four stories. Her writers harbour dark secrets or painful memories, or are driven to act out revenge tragedies not dissimilar to the ones they write about. I only hope I never get on her wrong side . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("I should, right at the start, have laid my cards on the table. I’ve known Val for years. But before I knew her, I knew her books. I was intrigued by the author biography on her early jackets. It seemed to me we must have grown up near one another. And so we did: five miles apart, yet we first met in Seattle, where we were both attending a crime-fiction convention. We went out drinking and talking and – eventually – singing. Since then, we’ve shared experiences which would make decent short stories in themselves . . . except that few people would believe them. The short story, after all, unlike real life, has to convince us that it could have happened, or might be happening right now. And this is the real trick of a good short story: it has to pull us into its world straight away, convincing us with immediately recognisable characters. Once snared, we can begin our descent into the dark confines of the plot. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("There are stories here which will make you shudder, and which will linger long in the mind. Tiny worlds of hurt and healing: the hurt we do to each other; the healing that comes with recognition. The recognition that we have these potentials within us. It’s up to us to choose between good and evil, love and destruction. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-7"
  }, [_vm._v("Ian Rankin")])])]), _c('a', {
    attrs: {
      "id": "Foreword"
    }
  })]), _c('a', {
    attrs: {
      "id": "Foreword"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42f223bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stranded_eBook5.vue
// module id = 75
// module chunks = 0